import { render, staticRenderFns } from "./BackToDescomplica.vue?vue&type=template&id=3e4dd21c&scoped=true&"
import script from "./BackToDescomplica.vue?vue&type=script&lang=ts&"
export * from "./BackToDescomplica.vue?vue&type=script&lang=ts&"
import style0 from "./BackToDescomplica.vue?vue&type=style&index=0&id=3e4dd21c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4dd21c",
  null
  
)

export default component.exports